import styled from "styled-components";
import PageSelector from "../atoms/main/PageSelector";
import PublicTemplate from "../publics/PublicTemplate";

const MainTemplate = () => {
  return (
    <PublicTemplate wrap>
      <Content>
        <PageSelector name="최대수요" path="/peak" />
        <PageSelector name="전체 기기 통신상태" path="/device" />
        <PageSelector name="구축현장 사이트 링크" path="/link" />
        <PageSelector name="S/C 및 E+ 온도 모니터링" path="/showcase" />
      </Content>
    </PublicTemplate>
  );
};

export default MainTemplate;

const Content = styled.div`
  width: 60%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;
